<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Welcome, {{ $store.state.first_name }}!</h3>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>
          <div class="mentor-container">
            <flash-message autoHide variant="success"></flash-message>
            <div class="row db-row mb-2" v-if="this.$store.state.user_locations.isUserLinkedMultipleLocations">
              <div class="col-12">
                  <img src="@/assets/enterprise/branded_location_icon.png" width="16">
                  <b>{{ current_location_name }}</b> {{ formatAddress(current_location_city,current_location_state) }}
              </div>
            </div>
            <div class="row db-row col-11 p-0" style="margin: 0 auto;">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" >


                    <db-card-list v-if="isApprenticesPanelVisible" 
                    card_title="Apprentices"
                    btnName="Add Apprentice"
                    btnLink="/add-apprentice"
                    btnType="add"
                    :count="apprenticesCount" 
                    :itemLength="apprenticesItems.length" 
                    :allItems="apprenticesItems"
                    tab_name="apprentices">
                    </db-card-list>
                    
                    <db-card-list v-if="isMenteePanelVisible" 
                    card_title="Mentees"
                    btnName="Add Mentee"
                    btnLink="/add-mentee"
                    btnType="add"
                    :count="menteeCount" 
                    :itemLength="menteeItems.length" 
                    :allItems="menteeItems"
                    tab_name="mentees">
                    </db-card-list>




                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" >

                  <div class="db-card">
                    <div class="col-12 p-0">
                      <h5 class="title">Reporting</h5>
                    </div>
                    <div class="col-12 p-0">
                      <div class="db-report-card" v-for="(item, index) in reportingItems" :key="index">
                        <div class="row" v-if="menteeCount > 0 || apprenticesCount > 0">
                          <div class="col-8 col-sm-10 col-md-8 col-lg-8 col-xl-8">
                            {{ item.name }}
                          </div>
                          <div class="col-4 col-sm-2 col-md-4 col-lg-4 col-xl-4">
                            <router-link :to="item.link" class="btn btn-primary btn-sm dbViewBtn">
                            View
                            </router-link>
                          </div>
                        </div>
                      </div>    
                    </div>
                  </div>


                  <div class="db-card">
                    <div class="col-12 p-0">
                      <h5 class="title">Assessments</h5>
                    </div>
                    <div class="col-12 p-0" v-if="assessments.length > 0">
                      <div class="" v-for="(assessment, aindex) in assessments" :key="aindex">
                        <div class="db-report-card" v-if="!assessment.complete_attempt_id">
                        <div class="row" >
                          <div class="col-8 col-sm-10 col-md-8 col-lg-8 col-xl-8">
                            <strong>{{ assessment.title }}</strong>
                            <div class="question_text">
                            {{ assessment.question_count }} Questions
                            </div>
                          </div>
                          <div class="col-4 col-sm-2 col-md-4 col-lg-4 col-xl-4 p-0" style="padding-top: 3px !important;">
                            <div class="col-12" style="text-align: right;">
                            <button type="submit" class="btn btn-primary btn-md begin-course-button" v-on:click="goToAssessmentLanding(assessment.id, assessment.inprogress_attempt_id, assessment.question_count)">{{ assessment.button_text }}</button> 
                            </div>
                            <div class="col-12 question_text" style="text-align: right; padding-right: 16px; text-decoration: underline;"  v-if="assessment.complete_attempt_id"> 
                            <router-link :to="'assessment-report/' + assessment.complete_attempt_id" style="">
                            View Results
                            </router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>    
                    </div>
                    <div class="col-12 p-0" v-if="forms.length > 0">
                      <div class="db-report-card" v-for="(form, findex) in forms" :key="findex">
                        <div class="row" >
                          <div class="col-8 col-sm-10 col-md-8 col-lg-8 col-xl-8">
                            <strong>{{ form.name}}</strong>                           
                          </div>
                          <div class="col-4 col-sm-2 col-md-4 col-lg-4 col-xl-4 p-0" style="padding-top: 3px !important;">
                            <div class="col-12" style="text-align: right;">
                            <button type="submit" class="btn btn-primary btn-md start-button begin-course-button" v-on:click="goToFillForm(form.id)">Fill Form</button> 
                            </div>
                            
                          </div>
                        </div>
                      </div>    
                    </div>
                    <div class="col-12 p-0" v-if="assessments.length == 0 && forms.length == 0">
                      <div class="db-report-card" style="font-style: italic; font-weight: bold;font-size: 13px; text-align: center;" >
                          No Assessments Assigned
                      </div>
                    </div>


                  </div>


                   <div class="db-card" v-if="courses.length > 0 || resources.length > 0">
                      <div class="col-12 p-0">
                        <h5 class="title">Courses</h5>
                      </div>

                      <div class="col-12 p-0" v-if="resources.length > 0">
                      <div class="db-report-card" v-for="(resource, rindex) in resources" :key="rindex">
                        <div class="row" >
                          <div class="col-8 col-sm-10 col-md-8 col-lg-8 col-xl-8">
                            <strong>{{ resource.name }}</strong>
                            <div class="question_text">
                            Resource
                            </div>
                          </div>
                          <div class="col-4 col-sm-2 col-md-4 col-lg-4 col-xl-4 p-0" style="padding-top: 3px !important;">
                            <div class="col-12" style="text-align: right;">
                            <button type="submit" class="btn btn-primary btn-md begin-course-button" @click="getResourceView(resource.filename)">View</button> 
                            </div>                          
                          </div>
                         </div>
                       </div>    
                      </div>  
                      
                      <div class="col-12 p-0" v-if="courses.length > 0">
                      <div class="db-report-card" v-for="(course, cindex) in courses" :key="cindex">
                        <div class="row" >
                          <div class="col-8 col-sm-10 col-md-8 col-lg-8 col-xl-8">
                            <strong>{{ course.title }}</strong>
                            <div class="question_text">
                            {{ course.noOfModules }} Modules
                            </div>
                          </div>
                          <div class="col-4 col-sm-2 col-md-4 col-lg-4 col-xl-4 p-0" style="padding-top: 3px !important;">
                            <div class="col-12" style="text-align: right;">
                            <button type="submit" class="btn btn-primary btn-md begin-course-button" v-on:click="goToCourseLanding(course.lmsCourseId)">{{getCourseBtnName(course.certification_download_link, course.courseStatus)}}</button> 
                            </div>
                            <div class="col-12 view-certificate" v-if="course.certification_download_link"> 
                              <a :href="course.certification_download_link" target="_blank">View Certificate</a>
                            </div>
                          </div>
                        </div>
                      </div>    
                    </div>
                      
                  </div>




                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

<!-- Bell icon to see the introduction slide -->
    <div class="fixed-bell-icon btn btn-primary" @click="showIntroductionSlide" v-if="introduction_slide_obj.length > 0">
       <i class="fa fa-bell" aria-hidden="true"></i>       
    </div>


      <IntroductionModal
      :isIntroductionModalVisible="isIntroductionModalVisible"
      :introductionSlideObj="introduction_slide_obj"
      :showSlideNumbers="showSlideNumbers"
      ref="introduction_modal"
      @close="isIntroductionModalVisible = false"
      >

      </IntroductionModal>


  </div>
</template>

<script>
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import { store } from '../../store/store';
import DbCardList from '../manager/db_card_list.vue';
import router from '../../router/index.js';
import IntroductionModal from '../manager/introductionManagerTemplateModal.vue';

const reportingLists = [
  {'name': 'Competency Progress', 'link': 'competency-report'},
  {'name': 'Rep Audit Trail', 'link': '/rep-audit-trail'},
  // {'name': 'Course Certificate', 'link': '/'}
];

export default {
    data: function () {
        return {
            account: [],
            lessMenteeItems: [],
            lessApprenticesItems: [],
            menteeItems: [],
            apprenticesItems: [],
            menteeCount: '',
            apprenticesCount: '',
            reportingItems: reportingLists, 
            assessments: [],
            courses: [],
            lmsUserId: '',
            isApprenticesPanelVisible: false,
            isMenteePanelVisible: false,
            forms:[],
            current_location_name: '',
            current_location_city: '',
            current_location_state: '',
            currentLocation: {},
            resources: [],
            introduction_slide_obj: [],
            isIntroductionModalVisible: false,
            showSlideNumbers: false,
        }
    },
    beforeCreate: function() {
      store.dispatch('active_tab', '');
   },
   methods: {
      goToAssessmentLanding: function(assessmentId, assessmentAttemptId, questionCount) {
        if(assessmentAttemptId) {
          router.push('/assessment-landing-page/' + assessmentId + '/' + assessmentAttemptId);
        }
        else {
          axios('/desktop/user-assessment-attempts/' + assessmentId + '/' + this.$store.state.user_accountid,
          {
            method: 'POST',
          })
          .then((resp) => {
            router.push('/assessment-landing-page/' + assessmentId + '/' + resp.data);
          })
          .catch(() => {

          });
        }
      },
     goToCourseLanding(courseId) {
        var dashboardPath = this.$route.fullPath;
        dashboardPath = dashboardPath.replace(/^\/+/,"");
       
        router.push('/take-course/'+ this.lmsUserId + '/' + dashboardPath + '?c=' + courseId);
     },
     goToFillForm: function(formId) {
        router.push('/display-fill-form/' + formId);
     },
     getCourseBtnName(certificate, courseStatus) {
      var res = 'Begin';
        if(certificate) {
          res = 'Re-Take';
        }
        else if(courseStatus == 1) {
          res = 'Continue';
        }
       return res;
     },
     formatAddress(city, state) {
      var address = '';
      if (city) {
          address += city + ", ";
      }
      if (state) {
          address += state + ", ";
      }
      return address.slice(0, -2);
    },
    getResourceView(fileLink) {
      window.open(fileLink, '_blank');
    },
    showIntroductionSlide() {
      this.$refs.introduction_modal.getDefaultSlide();
      this.isIntroductionModalVisible = true;      
    } 
   },
   created() {
      if (this.$store.state.user_locations.isUserLinkedMultipleLocations) {
        this.currentLocation = this.$store.state.user_locations.locations.find(loc => loc.accId === this.$store.state.user_accountid);
        this.current_location_name = this.currentLocation.accountName;
        this.current_location_city = this.currentLocation.city;
        this.current_location_state = this.currentLocation.stateName;
      }
      axios.get('/desktop/user/assessment-lists/' + this.$store.state.user_accountid, {
      })
      .then(response =>  {
        this.assessments = response.data.assessment;
      })
      .catch(function() {
        
      });

      axios.get('/desktop/user/form-lists/' + this.$store.state.user_accountid, {
        params: {
          user_roles: 'ROLE_MENTOR',
        }
      })
      .then(response =>  {
        this.forms = response.data;
      })
      .catch(function() {
        
      });

       var role = 'ROLE_MENTOR'; 
      
       axios.get('/desktop/user/resource-lists', {
           params: {
           user_roles: role,
           accountId: this.$store.state.user_accountid
          }
        })
        .then(response =>  {
          this.resources = response.data;
        })
        .catch(function() {
          
        });   

      axios.get('/desktop/user/course-lists/' + this.$store.state.user_accountid, {
      })
      .then(response =>  {
        this.courses = response.data.course;
      })
      .catch(function() {
        
      });

      axios.get('/user/get-lmsuserid', {
      })
      .then(response =>  {
        this.lmsUserId = response.data.lmsuserid;
      })
      .catch(function() {
        
      });

      axios('/desktop/mentee-lists/' + this.$store.state.user_accountid,
      {
          method: 'GET',
      })
      .then(response => {
          this.menteeCount = response.data.length;
          this.menteeItems = response.data;
      })
      .catch(() => {
      });

      axios('/desktop/apprentices-lists/' + this.$store.state.user_accountid,
      {
          method: 'GET',
      })
      .then(response => {
          this.account = response.data.account;
          this.apprenticesCount = response.data.apprentices.length;
          this.apprenticesItems = response.data.apprentices;
          if (this.account.program == 'Apprenticeship' || this.account.program == 'Mentorship & Apprenticeship') {
            this.isApprenticesPanelVisible = true;
          }
          if (this.account.program == 'Mentorship' || this.account.program == 'Mentorship & Apprenticeship') {
            this.isMenteePanelVisible = true;
          }
      })
      .catch(() => {
      });

      axios.get('/get-dashboard-introduction-slide', {
          params: {
            user_roles: 'ROLE_MENTOR',
            accountId: this.$store.state.user_accountid,
          }
      })
      .then(response =>  {
        this.introduction_slide_obj = response.data.introduction_slide;
        this.showSlideNumbers = response.data.showSlideNumbers;
        if(this.introduction_slide_obj.length > 0) {
        if(this.$store.state.introduction_template_display == 1) {
          setTimeout(() => {
          this.$refs.introduction_modal.getDefaultSlide();
          this.isIntroductionModalVisible = true;
          this.$store.dispatch('introduction_template_display', 0);
          }, 1000);
        }
        }
      })
      .catch(function() {
        
      });

   },
   components: {
    UserMenu,
    DbCardList,
    IntroductionModal,
   },
}
</script>

<style scoped>
.mentor-container {
  margin: 0px auto;
  width: 100%;
  padding-top: 0px;
}
.db-card {
  color: #002F42;
  background-color: #FFF;
  width: 100%;
  min-height: 120px;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;  
}
.db-card .title{
  font-size: 15px;
  font-weight: 900;
}
.db-card .empty-content-title{
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.db-card .acc-info {
  font-size: 13px;
  font-weight: 600;
  margin-left: 10px;
}
.db-card .db-report-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.db-card .db-empty-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  text-align: center;
}
.dbViewBtn{
  color: #29A3E4;
  background: none;
  border: 0px solid #00acee;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  width: 50px;
  float: right;
  text-decoration: underline !important;
}
.dbViewBtn:focus, .dbViewBtn:hover {
  color: #29A3E4 !important;
  background: none !important;
  box-shadow: none !important;
  border: 0px solid #00acee !important;
} 
/* media query css start */
@media (min-width: 992px) {
  .db-row {
    margin-left: 1rem;
  }
}
.question_text, .question_text a, .question_text a:hover {
  font-size: 11px;
  color: #002F42;
}
.start-button {
    color: #29A3E4;
    background-color: #FFF !important;
    border: 1px solid #29A3E4 !important;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 110px;
}
.begin-course-button {
    color: #fff;
    background-color: #29A3E4 !important;
    border: 1px solid #29A3E4 !important;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 110px; 
}
.view-certificate {
    text-align: right;
    padding: 10px 16px 3px 30px;
    font-size: 12px;
    color: #29A3E4;
}
.view-certificate a, .view-certificate a:hover{ 
  color: #29A3E4 !important;
  text-decoration: underline !important;
  font-weight: bold;
}
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
.fixed-bell-icon {
    position: fixed;
    right: 15px;
    bottom: 30px;
    border-radius: 50%;
    box-shadow: 1px 1px 11px 1px #a59a9a;
    font-size:25px;
    background-color: #29A3E4 !important;
    border-color: #29A3E4 !important; 
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/mentor/mentor_dashboard.vue